module.exports = __webpack_public_path__ + "img/16.8.TSS.5e48bff3.png";